<h3 class="my-4 heading text-center">Welcome to R1 340B Recovery</h3>
<app-create-password-form [mode]="createPasswordModes.newUser" />
